import globals from '../globals';

import setDomain from './setDomain';

export const getConfig = (key?: string, defaultValue?: any) => {
  const configuration = globals.window.__CONFIG__ || {};
  if (!key) {
    return configuration;
  }

  // config object is only 1 level deep
  const configValue = configuration[key];

  if (configValue !== undefined) {
    return setDomain(configValue);
  }

  if (defaultValue !== undefined) {
    return defaultValue;
  }
};
